import React from 'react'
import './Faqs.css'
import faqimg from '../../assets/logo/faqimg.png'

const Faqs = () => {
  return (
    <div className='faqs-more'>
        <div className='imgs'>
         {/* <img src={faqimg} alt=''/> */}
        </div>

        <h1 style={{textAlign:'center'}}></h1>

        <div className=' design gallery faq '>

        {/* <Link to="/contactForm" classNameName="btn btn-warning">Enquiry Form</Link> */}
        <div className="accordion accordion-flush" id="accordionFlushExample">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
                1. Does Artical Art deliver home interior projects only in select cities, or is the ssrvice available across india?
              </button>
            </h2>
            <div id="flush-collapseOne" className="accordion-collapse collapse" >
              <div className="accordion-body">
               Articalart delivers Commercial  and Residential projects in PAN India.
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header">
              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo">
                2. Apart from the promise of hasle-free  experience  and space-optimised home interiors, why should i hire ArticalArt ?
              </button>
            </h2>
            <div id="flush-collapseTwo" className="accordion-collapse collapse" >
              <div className="accordion-body">
                with Artical Art , you can forward to a hasle-free, personalised home and commercial design experience , from design board to delivery. With customised services and seamless delivery protocols, 
                you can trust us to breathe life into your vision and craft a tailor-made, space-optimised home within your budget.
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header">
              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseThree" aria-expanded="false" aria-controls="flush-collapseThree">
                3. Does Artical Art have an Experience Centre?
              </button>
            </h2>
            <div id="flush-collapseThree" className="accordion-collapse collapse" >
              <div className="accordion-body">
               Yes, Artical Art have Experience Centre(Factory) which is located in Dombivali.
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header">
              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseFour" aria-expanded="false" aria-controls="flush-collapseFour">
                4. Does Artical Art offer a delivery promise of 45 days?
              </button>
            </h2>
            <div id="flush-collapseFour" className="accordion-collapse collapse" >
              <div className="accordion-body">
                Yes, our delivery turnarounds start at 45 days
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header">
              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseFive" aria-expanded="false" aria-controls="flush-collapseFive">
                5. Are home decor and furniture included in your packages too?
              </button>
            </h2>
            <div id="flush-collapseFive" className="accordion-collapse collapse" >
              <div className="accordion-body">
              Yes, our packages include exclusive furniture and home decor, handpicked by our home interior designers in line with your envisioned aesthetic.
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header">
              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseSix" aria-expanded="false" aria-controls="flush-collapseSix">
                6. Do you undertake only home interior design projects?
              </button>
            </h2>
            <div id="flush-collapseSix" className="accordion-collapse collapse" >
              <div className="accordion-body">
             no we take both  <b>Residential</b> as well as <b>Commercial</b> interior projects.
                  
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header">
              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseSeven" aria-expanded="false" aria-controls="flush-collapseSeven">
                7.Will Artical Art keep me updated on my project status at every step?
              </button>
            </h2>
            <div id="flush-collapseSeven" className="accordion-collapse collapse" >
              <div className="accordion-body">
              At Artical Art, trust our interior designers to spearhead your project while you take it easy. Stay updated at every step with regular milestone updates via mail or call, all the way through to delivery.
                 
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header">
              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapse8" aria-expanded="false" aria-controls="flush-collapse8">
                8. Can I see my project in virtual reality?
              </button>
            </h2>
            <div id="flush-collapse8" className="accordion-collapse collapse" >
              <div className="accordion-body">
                Yes, we are working on this functionality.
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header">
              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapse9" aria-expanded="false" aria-controls="flush-collapse9">
                9. What are the steps to a Artical Art home or office?
              </button>
            </h2>
            <div id="flush-collapse9" className="accordion-collapse collapse" >
              <div className="accordion-body">
                Gain a Artical art  home in 3 easy steps. (1) Book an appointment and meet us (2) Tell us about your dream aesthetic and watch your home come to life in virtual reality (3) Get your transformed home or office  within the promised timeline (and move in!)
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordi-header">
              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapse10" aria-expanded="false" aria-controls="flush-collapse10">
                10. How do I get started with Artical Art?
              </button>
            </h2>
            <div id="flush-collapse10" className="accordion-collapse collapse" >
              <div className="accordion-body">
                Easy, just call us on +91-7666326326  and book an appointment Alterntively, walk into our corporate office, address given on website
              </div>
            </div>
          </div>
        
        </div>
       </div>

        <p className='disclaimer container'>Kindly note: Product images are representative and may not reflect exact offerings. Please contact us to create a design customized for you.</p>

    </div>
  )
}

export default Faqs   